const translations = {
  pl: {
    // Navigation - Client
    "nav.today": "Dziś",
    "nav.workout": "Trening",
    "nav.cardio": "Cardio",
    "nav.diet": "Dieta",
    "nav.progress": "Postęp",
    "nav.messages": "Czat",
    "nav.profile": "Profil",

    // Navigation - Trainer
    "nav.clients": "Klienci",
    "nav.groups": "Grupy",
    "nav.team": "Zespół",
    "nav.exercises": "Ćwiczenia",
    "nav.templates": "Szablony",
    "nav.running": "Cardio",
    "nav.calendar": "Kalendarz",
    "nav.habits": "Nawyki",
    "nav.metrics": "Metryki",
    "nav.nutrition": "Żywienie",
    "nav.forms": "Formularze",
    "nav.files": "Pliki",
    "nav.videos": "Wideo",
    "nav.alerts": "Alerty",
    "nav.payments": "Płatności",
    "nav.analytics": "Analityka",
    "nav.automations": "Automatyzacje",
    "nav.activity": "Aktywność",
    "nav.config": "Konfiguracja",

    // Sidebar groups
    "nav.group.health": "Zdrowie",
    "nav.group.communication": "Komunikacja",
    "nav.group.admin": "Admin",
    "nav.technique": "Technika",

    // Common actions
    "action.save": "Zapisz",
    "action.cancel": "Anuluj",
    "action.delete": "Usuń",
    "action.edit": "Edytuj",
    "action.add": "Dodaj",
    "action.create": "Utwórz",
    "action.confirm": "Potwierdź",
    "action.reject": "Odrzuć",
    "action.search": "Szukaj",
    "action.export": "Eksport",
    "action.download": "Pobierz",
    "action.close": "Zamknij",
    "action.back": "Wróć",
    "action.start": "Start",
    "action.stop": "Stop",
    "action.logout": "Wyloguj",

    // Calendar & Booking
    "calendar.title": "Kalendarz",
    "calendar.sessions": "Sesje",
    "calendar.availability": "Dostępność",
    "calendar.noSessions": "Brak sesji",
    "calendar.planSessions": "Zaplanuj sesje treningowe z klientami",
    "calendar.upcoming": "Nadchodzące",
    "calendar.history": "Historia",
    "calendar.newSession": "Nowa sesja",
    "calendar.pendingConfirmation": "Oczekujące na potwierdzenie",
    "calendar.addHours": "Dodaj godziny",
    "calendar.blockDay": "Wolne / Blokada",
    "calendar.regularHours": "Stałe godziny pracy",
    "calendar.noHoursSet": "Brak ustawionych godzin",
    "calendar.addAvailability": "Dodaj godziny dostępności, aby klienci mogli rezerwować sesje",
    "calendar.exceptions": "Wyjątki i dni wolne",
    "calendar.noExceptions": "Brak wyjątków — klienci mogą rezerwować zgodnie ze stałym grafikiem.",

    // Booking
    "booking.title": "Zarezerwuj sesję",
    "booking.mySessions": "Moje sesje",
    "booking.book": "Zarezerwuj",
    "booking.noSessions": "Brak zaplanowanych sesji — zarezerwuj termin!",
    "booking.connectFirst": "Połącz się z trenerem, aby rezerwować sesje",
    "booking.selectDate": "Wybierz datę i godzinę",
    "booking.availableSlots": "Dostępne godziny",
    "booking.loading": "Ładowanie...",
    "booking.noSlots": "Brak dostępnych terminów w tym dniu",
    "booking.requestSent": "Prośba o rezerwację wysłana!",
    "booking.cancelConfirm": "Anulować rezerwację?",
    "booking.cancelled": "Rezerwacja anulowana",

    // Session statuses
    "status.scheduled": "Zaplanowana",
    "status.pending": "Oczekuje",
    "status.confirmed": "Potwierdzona",
    "status.completed": "Zakończona",
    "status.cancelled": "Odwołana",
    "status.rejected": "Odrzucona",

    // Ratings
    "rating.title": "Oceń sesję",
    "rating.thanks": "Dziękujemy za ocenę!",
    "rating.excellent": "Doskonale!",
    "rating.veryGood": "Bardzo dobrze",
    "rating.ok": "W porządku",
    "rating.couldBeBetter": "Mogło być lepiej",
    "rating.poor": "Słabo",
    "rating.select": "Wybierz ocenę",
    "rating.comment": "Komentarz",
    "rating.commentPlaceholder": "Co było dobrze? Co można poprawić?",
    "rating.skip": "Pomiń",
    "rating.submit": "Oceń",
    "rating.avgRating": "śr. ocena",
    "rating.reviews": "ocen",
    "rating.noRatings": "Brak ocen — klienci mogą oceniać zakończone sesje",

    // Payments & KPI
    "payments.title": "Płatności",
    "payments.revenue": "Przychód",
    "payments.thisMonth": "ten miesiąc",
    "payments.totalRevenue": "Przychód łączny",
    "payments.activeSubscriptions": "Aktywne subskrypcje",
    "payments.unpaid": "Nieopłacone",
    "payments.overdue": "Przeterminowane",
    "payments.sessionsMonth": "Sesje (miesiąc)",
    "payments.activePackages": "Aktywne pakiety",
    "payments.exportCSV": "Eksport CSV",
    "payments.assignPackage": "Przypisz pakiet",
    "payments.newPackage": "Nowy pakiet",

    // Settings
    "settings.language": "Język",
    "settings.theme": "Motyw",
    "settings.profile": "Profil",

    // General
    "general.loading": "Ładowanie...",
    "general.error": "Wystąpił błąd",
    "general.noData": "Brak danych",
    "general.optional": "opcjonalne",
    "general.notes": "Notatki",
    "general.date": "Data",
    "general.time": "Godzina",
    "general.duration": "Czas",
    "general.type": "Typ",
    "general.client": "Klient",
    "general.trainer": "Trener",
    "general.min": "min",

    // Booking extended
    "booking.upcoming": "Nadchodzące",
    "booking.past": "Historia",
    "booking.all": "Wszystkie",
    "booking.empty.upcoming": "Brak zaplanowanych treningów",
    "booking.empty.past": "Brak historii treningów",
    "booking.cancel.title": "Anuluj trening",
    "booking.cancel.confirm": "Czy na pewno chcesz anulować ten trening?",
    "booking.cancel.lateWarning": "Trening jest za mniej niż 24 godziny. Sesja zostanie odjęta z pakietu.",
    "booking.new.success": "Rezerwacja wysłana! Trener otrzyma powiadomienie.",
    "status.absent": "Nieobecność",
    "status.lateCancel": "Późne anulowanie",

    // Trainer
    "trainer.pending.title": "Oczekujące rezerwacje",
    "trainer.pending.empty": "Brak oczekujących rezerwacji",
    "trainer.availability.title": "Moja dostępność",
    "trainer.leave.title": "Urlopy i zwolnienia",
    "trainer.leave.add": "Zgłoś urlop / L4",
    "trainer.leave.from": "Od",
    "trainer.leave.to": "Do",
    "trainer.leave.reason": "Powód (opcjonalnie)",
    "trainer.leave.type": "Typ",
    "trainer.leave.vacation": "Urlop wypoczynkowy",
    "trainer.leave.sickLeave": "L4 — zwolnienie lekarskie",
    "trainer.leave.training": "Szkolenie",
    "trainer.leave.personal": "Dzień osobisty",
    "trainer.leave.other": "Inny",
    "trainer.leave.days": "dni",
    "trainer.leave.noLeaves": "Brak zgłoszonych urlopów",
    "trainer.leave.cancelConfirm": "Anulować urlop?",
    "trainer.leave.sessionsWillCancel": "Sesje w tym terminie zostaną automatycznie odwołane.",
    "trainer.leave.documentUrl": "Link do dokumentu (np. skan L4)",

    // Health profile
    "health.goal.weightLoss": "Redukcja wagi",
    "health.goal.muscleGain": "Budowa masy",
    "health.goal.endurance": "Wytrzymałość",
    "health.goal.health": "Zdrowie ogólne",
    "health.goal.sportSpecific": "Przygotowanie sportowe",
    "health.level.beginner": "Początkujący",
    "health.level.intermediate": "Średniozaawansowany",
    "health.level.advanced": "Zaawansowany",
    "health.bmi.underweight": "Niedowaga",
    "health.bmi.normal": "Norma",
    "health.bmi.overweight": "Nadwaga",
    "health.bmi.obese": "Otyłość",

    // Notifications
    "notifications.title": "Powiadomienia",
    "notifications.empty": "Brak powiadomień",
    "notifications.markAllRead": "Oznacz jako przeczytane",
    "notifications.types.bookingRequest": "Nowa rezerwacja",
    "notifications.types.bookingConfirmed": "Rezerwacja potwierdzona",
    "notifications.types.bookingRejected": "Rezerwacja odrzucona",
    "notifications.types.bookingReminder": "Przypomnienie o treningu",
    "notifications.types.newMessage": "Nowa wiadomość",

    // Common extended
    "common.retry": "Spróbuj ponownie",
    "common.filter": "Filtruj",
    "common.all": "Wszystkie",

    // Days
    "day.monday": "Poniedziałek",
    "day.tuesday": "Wtorek",
    "day.wednesday": "Środa",
    "day.thursday": "Czwartek",
    "day.friday": "Piątek",
    "day.saturday": "Sobota",
    "day.sunday": "Niedziela",
  },

  en: {
    // Navigation - Client
    "nav.today": "Today",
    "nav.workout": "Workout",
    "nav.cardio": "Cardio",
    "nav.diet": "Diet",
    "nav.progress": "Progress",
    "nav.messages": "Chat",
    "nav.profile": "Profile",

    // Navigation - Trainer
    "nav.clients": "Clients",
    "nav.groups": "Groups",
    "nav.team": "Team",
    "nav.exercises": "Exercises",
    "nav.templates": "Templates",
    "nav.running": "Cardio",
    "nav.calendar": "Calendar",
    "nav.habits": "Habits",
    "nav.metrics": "Metrics",
    "nav.nutrition": "Nutrition",
    "nav.forms": "Forms",
    "nav.files": "Files",
    "nav.videos": "Videos",
    "nav.alerts": "Alerts",
    "nav.payments": "Payments",
    "nav.analytics": "Analytics",
    "nav.automations": "Automations",
    "nav.activity": "Activity",
    "nav.config": "Config",

    // Sidebar groups
    "nav.group.health": "Health",
    "nav.group.communication": "Communication",
    "nav.group.admin": "Admin",
    "nav.technique": "Technique",

    // Common actions
    "action.save": "Save",
    "action.cancel": "Cancel",
    "action.delete": "Delete",
    "action.edit": "Edit",
    "action.add": "Add",
    "action.create": "Create",
    "action.confirm": "Confirm",
    "action.reject": "Reject",
    "action.search": "Search",
    "action.export": "Export",
    "action.download": "Download",
    "action.close": "Close",
    "action.back": "Back",
    "action.start": "Start",
    "action.stop": "Stop",
    "action.logout": "Log out",

    // Calendar & Booking
    "calendar.title": "Calendar",
    "calendar.sessions": "Sessions",
    "calendar.availability": "Availability",
    "calendar.noSessions": "No sessions",
    "calendar.planSessions": "Schedule training sessions with your clients",
    "calendar.upcoming": "Upcoming",
    "calendar.history": "History",
    "calendar.newSession": "New session",
    "calendar.pendingConfirmation": "Pending confirmation",
    "calendar.addHours": "Add hours",
    "calendar.blockDay": "Day off / Block",
    "calendar.regularHours": "Regular working hours",
    "calendar.noHoursSet": "No hours set",
    "calendar.addAvailability": "Add availability hours so clients can book sessions",
    "calendar.exceptions": "Exceptions and days off",
    "calendar.noExceptions": "No exceptions — clients can book according to regular schedule.",

    // Booking
    "booking.title": "Book a session",
    "booking.mySessions": "My sessions",
    "booking.book": "Book",
    "booking.noSessions": "No scheduled sessions — book an appointment!",
    "booking.connectFirst": "Connect with a trainer to book sessions",
    "booking.selectDate": "Select date and time",
    "booking.availableSlots": "Available slots",
    "booking.loading": "Loading...",
    "booking.noSlots": "No available slots on this day",
    "booking.requestSent": "Booking request sent!",
    "booking.cancelConfirm": "Cancel booking?",
    "booking.cancelled": "Booking cancelled",

    // Session statuses
    "status.scheduled": "Scheduled",
    "status.pending": "Pending",
    "status.confirmed": "Confirmed",
    "status.completed": "Completed",
    "status.cancelled": "Cancelled",
    "status.rejected": "Rejected",

    // Ratings
    "rating.title": "Rate session",
    "rating.thanks": "Thanks for your rating!",
    "rating.excellent": "Excellent!",
    "rating.veryGood": "Very good",
    "rating.ok": "OK",
    "rating.couldBeBetter": "Could be better",
    "rating.poor": "Poor",
    "rating.select": "Select rating",
    "rating.comment": "Comment",
    "rating.commentPlaceholder": "What went well? What could improve?",
    "rating.skip": "Skip",
    "rating.submit": "Rate",
    "rating.avgRating": "avg. rating",
    "rating.reviews": "reviews",
    "rating.noRatings": "No ratings — clients can rate completed sessions",

    // Payments & KPI
    "payments.title": "Payments",
    "payments.revenue": "Revenue",
    "payments.thisMonth": "this month",
    "payments.totalRevenue": "Total revenue",
    "payments.activeSubscriptions": "Active subscriptions",
    "payments.unpaid": "Unpaid",
    "payments.overdue": "Overdue",
    "payments.sessionsMonth": "Sessions (month)",
    "payments.activePackages": "Active packages",
    "payments.exportCSV": "Export CSV",
    "payments.assignPackage": "Assign package",
    "payments.newPackage": "New package",

    // Settings
    "settings.language": "Language",
    "settings.theme": "Theme",
    "settings.profile": "Profile",

    // General
    "general.loading": "Loading...",
    "general.error": "An error occurred",
    "general.noData": "No data",
    "general.optional": "optional",
    "general.notes": "Notes",
    "general.date": "Date",
    "general.time": "Time",
    "general.duration": "Duration",
    "general.type": "Type",
    "general.client": "Client",
    "general.trainer": "Trainer",
    "general.min": "min",

    // Booking extended
    "booking.upcoming": "Upcoming",
    "booking.past": "History",
    "booking.all": "All",
    "booking.empty.upcoming": "No upcoming sessions",
    "booking.empty.past": "No session history",
    "booking.cancel.title": "Cancel session",
    "booking.cancel.confirm": "Are you sure you want to cancel this session?",
    "booking.cancel.lateWarning": "Session is less than 24 hours away. It will be deducted from your package.",
    "booking.new.success": "Booking sent! Your trainer will be notified.",
    "status.absent": "Absent",
    "status.lateCancel": "Late cancellation",

    // Trainer
    "trainer.pending.title": "Pending bookings",
    "trainer.pending.empty": "No pending bookings",
    "trainer.availability.title": "My availability",
    "trainer.leave.title": "Leaves & sick days",
    "trainer.leave.add": "Submit leave / L4",
    "trainer.leave.from": "From",
    "trainer.leave.to": "To",
    "trainer.leave.reason": "Reason (optional)",
    "trainer.leave.type": "Type",
    "trainer.leave.vacation": "Vacation",
    "trainer.leave.sickLeave": "Sick leave (L4)",
    "trainer.leave.training": "Training/Workshop",
    "trainer.leave.personal": "Personal day",
    "trainer.leave.other": "Other",
    "trainer.leave.days": "days",
    "trainer.leave.noLeaves": "No leaves submitted",
    "trainer.leave.cancelConfirm": "Cancel leave?",
    "trainer.leave.sessionsWillCancel": "Sessions during this period will be automatically cancelled.",
    "trainer.leave.documentUrl": "Document link (e.g. L4 scan)",

    // Health profile
    "health.goal.weightLoss": "Weight loss",
    "health.goal.muscleGain": "Muscle gain",
    "health.goal.endurance": "Endurance",
    "health.goal.health": "General health",
    "health.goal.sportSpecific": "Sport preparation",
    "health.level.beginner": "Beginner",
    "health.level.intermediate": "Intermediate",
    "health.level.advanced": "Advanced",
    "health.bmi.underweight": "Underweight",
    "health.bmi.normal": "Normal",
    "health.bmi.overweight": "Overweight",
    "health.bmi.obese": "Obese",

    // Notifications
    "notifications.title": "Notifications",
    "notifications.empty": "No notifications",
    "notifications.markAllRead": "Mark all as read",
    "notifications.types.bookingRequest": "New booking request",
    "notifications.types.bookingConfirmed": "Booking confirmed",
    "notifications.types.bookingRejected": "Booking rejected",
    "notifications.types.bookingReminder": "Session reminder",
    "notifications.types.newMessage": "New message",

    // Common extended
    "common.retry": "Try again",
    "common.filter": "Filter",
    "common.all": "All",

    // Days
    "day.monday": "Monday",
    "day.tuesday": "Tuesday",
    "day.wednesday": "Wednesday",
    "day.thursday": "Thursday",
    "day.friday": "Friday",
    "day.saturday": "Saturday",
    "day.sunday": "Sunday",
  }
};

export default translations;
